import axios from 'axios';
import { VI_LANG } from 'constants/global';
import getMessageError from 'helpers/error/getMessageError';
import getSystem from 'helpers/getSystem';
import queryString from 'query-string';

const windowEnvConfig = window['runConfig'];

// Set up default config for http requests here
// Please have a look at here `https://github.com/axios/axios#request- config` for the full list of configs

const axiosClientNotATL = axios.create({
    baseURL: windowEnvConfig.REACT_APP_BASE_API_URL,
    headers: {
        'content-type': 'application/json',
        "X-Requested-With": "XMLHttpRequest",
    },
    paramsSerializer: params => queryString.stringify(params),
});

axiosClientNotATL.interceptors.request.use(async (config) => {
    const local = localStorage.getItem("locale") || VI_LANG;


    config.headers.lang = local;

    config.headers.system = getSystem();

    return config;
});

axiosClientNotATL.interceptors.response.use((response) => {

    if (response?.data) {

        return response.data;
    }

    return response;
}, (error) => {
    // Handle errors
    const local = localStorage.getItem("locale") || VI_LANG;

    getMessageError(local, error.message);
    throw error;
});

export default axiosClientNotATL;
